import * as React from 'react';
import classnames from 'classnames'
import * as moment from 'moment'
import * as _ from 'lodash'
import { ComboBox, Toggle, TextField, TooltipHost, Link, Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/index';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { log } from 'util'
import Wrapper, { DEFAULT_HELP_LINKS } from './Wrapper'
import FileUploadButton from './FileUploadButton'
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { clientLog } from '../util'

export interface Props {
    account: any,
    campaign: any,
    showIntro: boolean,
    filename: string,
    fileRows: number,
    fileDownloadUrl: string,
    fileUploaded: moment.Moment,
    columns: string[],
    onFileUpload: (files: FileList) => void,
    onAddTemplateToken: (tokenKey: string, toSubject: boolean) => void,
    onAddUnsubscribeLink: () => void,
    onPreview: () => void,
    onSignout: () => void,
    readTrackingEnabled: boolean,
    linkTrackingEnabled: boolean,
    unsubscribeEnabled: boolean,
    onReadTrackingEnabledChanged: (value: boolean) => void,
    onLinkTrackingEnabledChanged: (value: boolean) => void,
    onUnsubscribeEnabledChanged: (value: boolean) => void,
    onBccChanged: (value: string) => void,
    onNameChanged: (value: string) => void,
    onReplyToChanged: (value: string) => void,
    onDelayChanged: (value: number) => void,
    onCancelCampaign: () => void,
    attachmentWarning: boolean,
    autoLogin: (any, string) => string,
}

export interface State {
    isTeachingBubbleVisible: boolean;
    selectedTokenKey: string;
}

export default class CampaignView extends React.Component<Props, State> {
    private campaignDataPara: HTMLElement;
    private toggleID1: string = getId('tooltipHost-toggle1');
    private toggleID2: string = getId('tooltipHost-toggle2');
    private toggleID3: string = getId('tooltipHost-toggle3');

    constructor(props, context) {
        super(props, context);
        this.state = {
            isTeachingBubbleVisible: props.showIntro,
            selectedTokenKey: null
        };

        this.onDismissTeachingBubble = this.onDismissTeachingBubble.bind(this);

    }

    async componentDidMount() {
    }

    onDismissTeachingBubble = (event) => {
        this.setState({
            isTeachingBubbleVisible: !this.state.isTeachingBubbleVisible
        });
    }

    render() {
        const {
            account,
            filename,
            fileDownloadUrl,
            fileUploaded,
            fileRows,
            columns,
            onAddTemplateToken,
            onAddUnsubscribeLink,
            readTrackingEnabled,
            linkTrackingEnabled,
            unsubscribeEnabled,
            onReadTrackingEnabledChanged,
            onLinkTrackingEnabledChanged,
            onUnsubscribeEnabledChanged,
            onBccChanged,
            onNameChanged,
            onReplyToChanged,
            onDelayChanged,
            onCancelCampaign,
            onPreview,
            onSignout,
            campaign,
            attachmentWarning,
            autoLogin,
        } = this.props;
        const {
            isTeachingBubbleVisible,
            selectedTokenKey,
        } = this.state;

        return (<>
            {isTeachingBubbleVisible ?
                <div className="mm-intro ms-bgColor-themePrimary">
                    <div className="-header">
                        <p className="ms-font-xxl">Congratulations, you've created your new campaign</p>
                    </div>
                    <div className="-body">
                        <p className="ms-font-m ms-fontWeight-semilight">You've uploaded your campaign data. Next, you can compose your email and add personalization fields. When you're ready, check your campaign options and send the email.</p>
                    </div>
                    <div className="-footer">
                        <PrimaryButton onClick={this.onDismissTeachingBubble}>OK</PrimaryButton>
                        <Link target="_blank" href="https://mm365.me/tutorials" style={{ color: "white", marginLeft: "1rem" }}>More Information</Link>
                    </div>
                </div> : null}
            {attachmentWarning && <MessageBar
                messageBarType={MessageBarType.severeWarning}>
                Message size may not exceed 3MB in total (incl. all attachments).{' '}
                <Link href="https://mm365.me/faq-attachments" target="_blank">Visit the help page.</Link>
            </MessageBar>}
            <Wrapper
                onSignout={onSignout}
                account={account}
                autoLogin={autoLogin}
                campaignID={campaign && campaign.campaignID}
                className={classnames("mm-campaign mm-view")}>


                {fileRows == 0 && <><div className="mm-para -first" >
                    <p className="ms-font-l -label" style={{ marginTop: "1rem", fontWeight: 400 }} ref={(e) => (this.campaignDataPara = e!)}>New Campaign started</p>

                    <div className="ms-font-m -label" style={{ "lineHeight": "150%", "display": "flex", "alignItems": "center" }}>
                        <Spinner size={SpinnerSize.small} style={{ marginRight: ".5em" }} />
                        <span>Please wait. File is being processed.</span>
                    </div>
                </div></>}
                {fileRows > 0 && <>

                    <div className="mm-para -first" >
                        <p className="ms-font-l -label" style={{ marginTop: "1rem", fontWeight: 400 }} ref={(e) => (this.campaignDataPara = e!)}>Campaign data</p>

                        <div className="ms-font-m -label" style={{ "lineHeight": "150%" }}>Using <Link target="_blank" href={autoLogin(account, `/campaigns/${campaign.campaignID}/data`)}>{filename}</Link> with {fileRows} rows of recipients uploaded <span title={fileUploaded.format()}>{fileUploaded.fromNow()}</span>. <FileUploadButton key={fileUploaded.valueOf()} small={true} onFileUpload={this.props.onFileUpload} /></div>
                    </div>

                    {columns && columns.length > 0 && <div className="mm-para">
                        <div className="ms-font-m ms-fontWeight-semibold -label">Add personalization field to email</div>
                        <div className="">
                            <ComboBox
                                allowFreeform={false}
                                autoComplete={'on'}
                                options={columns && _.map(columns, c => ({ key: c, text: c }))}
                                onChange={(event, option, index, value) => {
                                    if (option != null) {
                                        this.setState({ selectedTokenKey: option.key.toString() })
                                    }
                                }}
                                selectedKey={selectedTokenKey}
                            />
                            <div className="mm-flexrow" style={{ "display": "flex", "flexDirection": "row", "alignItems": "center", "marginTop": ".5em", "marginBottom": "1em" }}>
                                <span>Add to</span>
                                <DefaultButton title="Adds the selected column to the subject line"
                                    style={{ marginLeft: ".5em" }}
                                    onClick={(event) => selectedTokenKey != null && onAddTemplateToken(selectedTokenKey, true)}
                                    disabled={selectedTokenKey == null || selectedTokenKey.length == 0}
                                >subject</DefaultButton>

                                <span style={{ marginLeft: ".5em" }}>or</span>
                                <DefaultButton title="Adds the selected column to the email body"
                                    style={{ marginLeft: ".5em" }}
                                    onClick={(event) => selectedTokenKey != null && onAddTemplateToken(selectedTokenKey, false)}
                                    disabled={selectedTokenKey == null || selectedTokenKey.length == 0}
                                >message</DefaultButton>
                            </div>
                        </div>
                        <div style={{ "marginTop": "5px" }} id="tst" onMouseEnter={onPreview}>
                            <PrimaryButton target="_blank" href={autoLogin(account, '/campaigns/{campaignID}/preview'.replace('{campaignID}', campaign.campaignID))}>Preview Email</PrimaryButton>
                        </div>
                    </div>}
                </>}

                {campaign && fileRows > 0 && 
                    <div className="mm-para">
                        <p className="ms-font-l -label" style={{ marginTop: "1.5rem", fontWeight: 400 }}>Options</p>
                        {campaign && campaign.multipleToOrCc &&
                            <div className="mm-para -small ms-font-s -label mm-warning">
                                <label>Warning:</label> Your campaign contains multiple recipients (either To or Cc) for at least one email. We recommend turning off tracking as this can lead to unintended consequences. Read more <a href="https://mm365.me/warning-multipletoandcc" target="_blank">here</a>.
                        </div>
                        }

                        <div className="mm-para -small">
                            <Toggle
                                aria-labelledby={this.toggleID1}
                                defaultChecked={readTrackingEnabled}
                                onText="Open tracking is enabled"
                                offText="Open tracking is disabled"
                                onChange={() => onReadTrackingEnabledChanged(!readTrackingEnabled)}
                            />
                        </div>

                        <div className="mm-para -small">

                            <Toggle
                                aria-labelledby={this.toggleID2}
                                defaultChecked={linkTrackingEnabled}
                                onText="Click tracking is enabled"
                                offText="Click tracking is disabled"
                                onChange={() => onLinkTrackingEnabledChanged(!linkTrackingEnabled)}
                            />
                        </div>

                        <div className="mm-para -small">

                            <div style={{
                                "display": "flex",
                                "flexDirection": "column"
                            }}>
                                <Toggle
                                    aria-labelledby={this.toggleID3}
                                    defaultChecked={unsubscribeEnabled}
                                    onText="Unsubscription is enabled"
                                    offText="Unsubscription is disabled"
                                    onChange={() => onUnsubscribeEnabledChanged(!unsubscribeEnabled)}
                                />
                                {unsubscribeEnabled && <>
                                    <div style={{ "marginTop": ".5em" }} className="mm-icon">
                                        <i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
                                        <Link title="Adds a unsubscribe link to the compose window at the current cursor position"
                                            onClick={(event) => onAddUnsubscribeLink()}
                                        >Add unsubscribe link to email</Link>
                                    </div>
                                    <div style={{ "marginTop": ".5em" }} className="mm-icon">
                                        <i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
                                        <Link target="_blank"
                                            href="/account/"
                                        >Unsubscription page settings</Link>
                                    </div>
                                </>}
                            </div>
                        </div>
                        <div className="mm-para -small">
                            <TextField
                                label="Set Campaign Name"
                                placeholder="optional"
                                defaultValue={campaign.name || ''}
                                onBlur={(event) => onNameChanged(event.target.value)} />
                        </div>


                        <div className="mm-para -small">
                            <TextField
                                label="Add BCC to each sent email"
                                placeholder="optional"
                                defaultValue={campaign.bcc || ''}
                                onBlur={(event) => onBccChanged(event.target.value)} />
                        </div>

                        <div className="mm-para -small">
                            <TextField
                                label="Set Reply-To for each sent email"
                                placeholder="optional"
                                defaultValue={campaign.replyTo||''}
                                onBlur={(event) => onReplyToChanged(event.target.value)} />
                        </div>

                        <div className="mm-para -small">
                            <TextField
                                type="number"
                                min="0"
                                max="300"
                                label="Seconds delay between each sent email"
                                placeholder="optional"
                                defaultValue={campaign.delayInSecondsForEachCampaignMail || null}
                                onBlur={(event) => onDelayChanged(Number.isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value))} />
                        </div>


                    </div>
                }
                <div className="mm-para -small">
                    {fileRows > 0 &&
                        <div className="ms-font-m ms-fontWeight-semibold -label" style={{ "marginTop": "1.5em", "lineHeight": "150%", "fontWeight": 700 }}>When you're ready, click Send in Outlook to start generating the campaign.</div>}
                    <DefaultButton
                        className="mm-dangerButton"
                        style={{ "marginTop": fileRows > 0 ? ".5em" : "1.5em" }}
                        onClick={onCancelCampaign}
                    >Cancel and delete campaign</DefaultButton>
                </div>
            </Wrapper>
        </>
        );
    }
}
